export const MAIN_TITLE = "ΕΝΓ-Δ-Δημοτικού-Ε6"
export const BOOK_TITLE = "ΕΝΓ-Δ-Δημοτικού-Ε6"